export { default as TermBody } from './TermBody/TermBody';
export type { TermBodyProps } from './TermBody/TermBody';
export { default as PrivacyPolicy } from './PrivacyPolicy/PrivacyPolicy';
export type { PrivacyPolicyProps } from './PrivacyPolicy/PrivacyPolicy';
